import { useEffect, useRef } from 'react'
import type { Tab } from 'shared/components/Form/types'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type PageTabsProps = WithClassName<{
	tabs: Tab[]
	activeTab: string
	label: string
	onChange: (value: string) => void
}>

export const PageTabs = ({ tabs, activeTab, label, className, onChange }: PageTabsProps) => {
	const activeTabRef = useRef<HTMLButtonElement>(null)

	useEffect(() => {
		activeTabRef.current?.scrollIntoView({ block: 'nearest', inline: 'nearest' })
	}, [activeTab])

	return (
		<div className={cn('overflow-x-auto px-2 lg:px-5', className)}>
			<div role="tablist" aria-label={label} className="flex min-w-max gap-1">
				{tabs.map((tab) => {
					const isActive = tab.value === activeTab

					return (
						<button
							key={tab.value}
							ref={isActive ? activeTabRef : undefined}
							type="button"
							role="tab"
							aria-selected={isActive}
							className={cn(
								'relative whitespace-nowrap rounded-t-md px-3 py-2.5 text-[13px] font-medium transition-colors',
								isActive
									? 'text-primary after:absolute after:inset-x-2 after:bottom-0 after:h-[2px] after:rounded-full after:bg-primary'
									: 'text-muted-foreground hover:bg-muted hover:text-foreground'
							)}
							onClick={() => onChange(tab.value)}>
							{tab.label}
						</button>
					)
				})}
			</div>
		</div>
	)
}
